/* tslint:disable */

declare var Object: any;
export interface Question_companyInterface {
  "questionId": number;
  "companyId": number;
  "isDeleted"?: boolean;
  "id"?: number;
}

export class Question_company implements Question_companyInterface {
  "questionId": number;
  "companyId": number;
  "isDeleted": boolean;
  "id": number;
  constructor(data?: Question_companyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Question_company`.
   */
  public static getModelName() {
    return "Question_company";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Question_company for dynamic purposes.
  **/
  public static factory(data: Question_companyInterface): Question_company{
    return new Question_company(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Question_company',
      plural: 'Question_companies',
      path: 'Question_companies',
      idName: 'id',
      properties: {
        "questionId": {
          name: 'questionId',
          type: 'number'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "isDeleted": {
          name: 'isDeleted',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
